import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SecurityScannedHistory = () => {
  const [scannedVisitors, setScannedVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    fetchScannedHistory();
  }, []);

  const fetchScannedHistory = async () => {
    try {
      const response = await axios.get(`${API}/visitors/scanned`);
      setScannedVisitors(response.data);
    } catch (error) {
      console.error('Error fetching scanned history:', error);
      toast.error('Error al cargar historial de escaneos');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Historial de Escaneos</h1>
        <Link to="/security" className="btn-back">
          ← Volver
        </Link>
      </div>

      <div className="stats-section">
        <div className="stat-card">
          <div className="stat-value">{scannedVisitors.length}</div>
          <div className="stat-label">Total Escaneados</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">
            {scannedVisitors.filter(v => {
              const scannedDate = new Date(v.scanned_at);
              const today = new Date();
              return scannedDate.toDateString() === today.toDateString();
            }).length}
          </div>
          <div className="stat-label">Hoy</div>
        </div>
      </div>

      {scannedVisitors.length === 0 ? (
        <div className="empty-state">
          <p>No has escaneado ningún código QR aún</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Área</th>
                <th>Placa</th>
                <th>Fecha Escaneo</th>
              </tr>
            </thead>
            <tbody>
              {scannedVisitors.map((visitor) => (
                <tr key={visitor.id}>
                  <td className="visitor-name-cell">{visitor.name}</td>
                  <td>
                    <span className="visitor-type">{visitor.visitor_type}</span>
                  </td>
                  <td>
                    <span className="area-badge">{visitor.area}</span>
                  </td>
                  <td>{visitor.vehicle_plate || '-'}</td>
                  <td>{formatDate(visitor.scanned_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SecurityScannedHistory;
